import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Function to scroll to top when navigation occurs
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <p className="text-gray-300 mb-4">
              Commissionerate of Rural Development and Panchayat Raj (Training)
            </p>
            
            <h3 className="text-lg font-bold mb-4">Websites</h3>
            <ul className="space-y-2">
              <li><a href="https://trainingonline.gov.in/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">Training Management Portal</a></li>
              <li><a href="https://rgsa.gov.in/index.htm" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">Revamped Rashtriya Gram Swaraj Abhiyan (RGSA)</a></li>
              <li><a href="https://tnrd.tn.gov.in/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">Tamil Nadu Rural Development & Panchayat Raj Department</a></li>
              <li><a href="https://pfms.nic.in/Home.aspx" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">Public Financial Management System (PFMS)</a></li>
              <li><a href="https://pai.gov.in/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">Panchayat Advancement Index (PAI) Portal</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" onClick={handleLinkClick} className="text-gray-300 hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/about" onClick={handleLinkClick} className="text-gray-300 hover:text-blue-400 transition-colors">About Us</Link></li>
              <li><Link to="/documents" onClick={handleLinkClick} className="text-gray-300 hover:text-blue-400 transition-colors">Documents</Link></li>
              <li><Link to="/schemes" onClick={handleLinkClick} className="text-gray-300 hover:text-blue-400 transition-colors">Schemes</Link></li>
              <li><Link to="/login" onClick={handleLinkClick} className="text-gray-300 hover:text-blue-400 transition-colors">SIRD, RIRD and District's Login</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <div>
              <h4 className="font-medium text-blue-400 mb-2">Commissionerate of Rural Development and Panchayat Raj (Training)</h4>
              <p className="text-gray-300 mb-1">Panagal Building, Saidapet, Chennai - 600015</p>
              <p className="text-gray-300 mb-1">Phone: +91 44-24344624</p>
              <p className="text-gray-300">Email: Crdtrg@gmail.com</p>
            </div>
          </div>
        </div>
        
       <div className="mt-12 pt-8 border-t border-gray-700 text-center text-gray-400">
  <p>
    <span className="text-white">Designed and developed by </span>
    <a href="https://klabsindia.com/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-white-400 transition-colors font-medium">
      K Labs Technology & Solutions
    </a>
  </p>
</div>
      </div>
    </footer>
  );
};

export default Footer;